<template>
    <div class="navitest">
        <div class="main">
            <h3>Werbung from Server</h3>

            <TableView :headers="columns" :rows="store.advertising" :sort="sort1" :pagination="pagination">
                <template v-slot:items="{ row }">
                    <td v-html="row.file.title"></td>
                    <td>{{ row.dauer }}</td>
                    <td>{{ row.tage }}</td>
                    <td>{{ row.multiplikator }}</td>
                </template>

                <template v-slot:no-data>
                    <span>No data</span>
                </template>
            </TableView>

            <h3>Werbung Array</h3>

            <TableView :headers="columns" :rows="advertising" :sort="sort1" :pagination="pagination">
                <template v-slot:items="{ row }">
                    <td v-html="row.file.title"></td>
                    <td>{{ row.dauer }}</td>
                    <td>{{ row.tage }}</td>
                    <td>{{ row.multiplikator }}</td>
                    <td>{{ row.duplicate }}</td>
                    <td>{{ row.id }}</td>
                </template>

                <template v-slot:no-data>
                    <span>No data</span>
                </template>
            </TableView>

        </div>

    </div>

</template>

<script>
    import * as nodes from '@/nodes.js'
    import TableView from '@/components/TableView'

    export default {
        name: 'Werbung',
        components: {TableView},
        data() {
            return {
                routes: [],
                advertising: [],
                columns: [
                    { label: 'File', field: 'name', sortable:true, type:"String" },
                    { label: 'Dauer', field: 'name', sortable:true, type:"String" },
                    { label: 'Tage', field: 'name', sortable:true, type:"String" },
                    { label: 'Multiplicator', field: 'name', sortable:true, type:"String" },
                ],
                sort1:{
                    field: 'first_name',
                    order: 'asc'
                },
                pagination:{
                    itemsPerPage: 100,
                    align: 'center',
                    visualStyle: 'select'
                }

            }
        },
        props: ['store'],
        methods: {


        },
        created(){
            let v = this
            let undistributedArray = [];

            this.store.advertising.forEach(function (el, key) {
                for (let i=0; i < el.multiplikator; i++ ){
                    // console.log(i);
                    if ( i > 0 ){
                        el['duplicate'] = true
                        undistributedArray.push({
                            file: el.file,
                            name: el.file.name,
                            duplicate: el.duplicate,
                            dauer: el.dauer,
                            tage: el.tage,
                            multiplikator: el.multiplikator,
                            id: i,
                            originkey: key
                        } )
                    } else {
                        el['duplicate'] = false
                    }
                    // console.log(el['duplicate'])

                }
                v.advertising.push(el);
            })
            console.log('adlength: '+ v.advertising.length)
            console.log(undistributedArray)

            let advertisinglength = v.advertising.length;
            let totalLength = undistributedArray.length + v.advertising.length;
            undistributedArray.forEach(function (el, key) {
                console.log('element:'+el.file.name);
                let frequency = ~~(totalLength / el.multiplikator);
                // calculated position
                let pos = frequency *(el.id) + ~~(el.originkey) ;

                //wrap around if pos greater than array length
                if (pos > advertisinglength){
                    pos = pos % advertisinglength;
                }
                console.log('original pos:'+el.originkey)
                console.log('frequenct:'+frequency)
                console.log('inserting into pos:' + pos);
                v.advertising.splice(pos, 0, el);

            })
        }
    }
</script>

<style scoped lang="scss">
    .bold {
        font-weight: 700;
    }

    .table {

        border: 1px solid black;
        /*padding: 10px;*/
        font-size: 14px;

        .header.row{
            font-weight: 700;
        }
        .row {
            display: flex;
            padding: 5px;
            span {
                width: 100%;
            }
            &:nth-child(even){
                background: #efefef;
            }
        }

    }
</style>
